import { AdminLayout } from '@/components/layouts'
import { useForm } from '@inertiajs/react'
import BadgeForm from './BadgeForm'

interface Community {
  id: number
  name: string
}

interface ConditionType {
  value: string
  label: string
}

interface NewProps {
  categories: string[]
  communities: Community[]
  condition_types: ConditionType[]
}

export default function New({ categories, communities, condition_types }: NewProps) {
  const form = useForm({
    name: '',
    description: '',
    emoji: '🏆',
    category: 'community',
    community_id: '',
    points_reward: '0',
    condition_type: '',
    condition_value: {}
  })

  const handleSubmit = (e: React.FormEvent) => {
    e.preventDefault()
    form.post('/admin/badges')
  }

  return (
    <AdminLayout
      title="Nouveau badge"
      breadcrumbs={[
        { label: 'Badges', href: '/admin/badges' },
        { label: 'Nouveau badge' }
      ]}
    >
      <BadgeForm
        data={form.data}
        setData={form.setData}
        errors={form.errors}
        processing={form.processing}
        onSubmit={handleSubmit}
        categories={categories}
        communities={communities}
        conditionTypes={condition_types}
        submitLabel="Créer le badge"
        cancelHref="/admin/badges"
      />
    </AdminLayout>
  )
}
